// extracted by mini-css-extract-plugin
export var container = "_4g-1";
export var cornerButtonContainer = "_4g-5";
export var disabled = "_4g-2";
export var fileContainer = "_4g-4";
export var hiddenInput = "_4g-3";
export var widthContainer = "_4g-0";